import Sidebar, { SidebarItem } from '.';
import useStore from '../Hooks/useStore';
import Select, { SelectItem } from '../Select';

interface SidebarExportProps {
  children: any;
}

const Body = () => {
  const [getters, setters] = useStore();

  const {
    invoice: { getInvoice },
  } = getters;

  const {
    invoice: {
      selectGroup
    },
  } = setters;

  const groups = getInvoice("groups.all");
  const selectedGroupId = getInvoice("selectedGroupId");

  const selectedGroup = groups.find(({ id }) => id === selectedGroupId);

  const groupItems = [
    ...(groups.length > 1 ? [{ id: 0, name: 'Todos' }] : []),
    ...groups.map(({ id, name }) => ({ id, name: `${id} - ${name}` })),
  ];

  const handleSelectGroup = (group: SelectItem) => {
    selectGroup(group.id);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        marginRight: "1rem",
      }}
    >
      {groupItems.length > 1 ? (
        <Select
          value={selectedGroup ? `${selectedGroup.id} - ${selectedGroup.name}` : undefined}
          label={selectedGroup ? `${selectedGroup.id} - ${selectedGroup.name}` : "Todos"}
          items={groupItems}
          onSelected={handleSelectGroup}
        />
      ) : (<>{selectedGroup ? `${selectedGroup.id} - ${selectedGroup.name}` : undefined}</>)}
    </div>
  );
}


export function SidebarExport({ children }: SidebarExportProps) {
  const items: SidebarItem[] = [
    {
      name: 'Dashboard',
      path: '/tools/exports',
      rule: {
        action: 'read',
        subject: 'Invoice',
      },
    },
    {
      name: 'Invoices',
      path: '/tools/exports/invoices',
      rule: {
        action: 'read',
        subject: 'Invoice',
      },
    },
    {
      name: 'Depósitos',
      path: '/tools/exports/deposits',
      rule: {
        action: 'read',
        subject: 'Deposit',
      },
    },
    {
      name: 'Logística',
      path: '/tools/exports/logistic',
      rule: {
        action: 'read',
        subject: 'Logistic',
      },
    },
    {
      name: 'Taxas',
      path: '/tools/exports/taxes',
      rule: {
        action: 'read',
        subject: 'Tax',
      },
    },
    {
      name: 'Companhias',
      path: '/tools/exports/companies',
      rule: {
        action: 'read',
        subject: 'Company',
      },
    },
  ];

  return <Sidebar items={items} children={children} body={<Body />} />;
}
